import  { useContext, useState } from "react";
import { IskconContent, BookContent, Tsize, View, Colour, FontType, Bplay, Hindit, Header, UserAudios } from "../global";
import { useHistory, useParams } from "react-router-dom";
import ScrollToTop from "../scroll";
import { motion } from "framer-motion";
import {
 IonButton,
 IonLabel,
 IonToolbar,
 IonButtons,
 IonCard,
 IonCardContent,
 IonPage,
 IonHeader,
 IonContent
} from "@ionic/react";
import {
 ViewAgendaSharp,
 ViewHeadlineSharp,
 MenuBookSharp,
 ArrowBackSharp,
 MoreVertSharp
} from "@mui/icons-material";

import {Helmet} from "react-helmet";

import YouTubePlayer from "../music/youtubeplayer";
import Music from "../music/music";


function Csong(props) {


 const content = useContext(BookContent);
 const [tsize,] = useContext(Tsize);
 const [view,] = useContext(View);
 const [iskcon,] = useContext(IskconContent);
 const [font,] = useContext(FontType);
 const [, setBplay] = useContext(Bplay);
 const [header, ] = useContext(Header);
 const [userAudios, ] = useContext(UserAudios)



 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 let { ind } = useParams();

 let dnind = ind.slice(0, ind.indexOf("_"));

 let nind;

 if (isNaN(dnind)) {
  for (let i in iskcon.songs) {
   if (iskcon.songs[i].name === dnind) {
    nind = i;
   }
  }
 } else nind = Number(dnind);

 let iname = ind.slice(ind.indexOf("_") + 1, ind.indexOf("_", ind.indexOf("_") + 1));
 let i1;

 if(iname){
 if (isNaN(iname)) {
 for (let i in content) {
  if (content[i].name === iname) {
   i1 = Number(i);
  }
 }
 }else i1=Number(iname)
 }
 let i2, id;
 if (i1 !== undefined) {
  if (content[i1].chap.length > 0) {
   i2 = Number(ind.slice(ind.indexOf("_", ind.indexOf("_") + 1) + 1, ind.lastIndexOf("_")));
  }
  id = Number(ind.slice(ind.lastIndexOf("_") + 1));
 }

 let vtm;
 if (view === "2") vtm = false;
 else vtm = true;
 const [vtb, setVtb] = useState(vtm);
 let index = 1;
 let present = 0;
 let iarr = [];
 let history = useHistory();
 const songName = iskcon.songs[nind].name
 let share_url=`https://vsnectar.web.app/home/songs/${songName}_${iskcon.songs[nind].book ?? ""}`;
 const [clr, ] = useContext(Colour);
 const [hindit, ] = useContext(Hindit);

 
 let color,color2,color3,colori,colorh;
 if(clr === "1") {
  color = "#00CBFE";
  color2 = "#04010f";
  color3 = "black"
  colori = "light"
  colorh = "primary"
 }
 if(clr === "2") {
  color = "#FFE34D";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
 }
 if(clr === "3") {
  color = "#FFA500";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
 }
 if(clr === "4") {
  color = "#87CEEB";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
 }
 if(clr === "5") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "warning"
 }
 if(clr === "6") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "tertiary"
 }

 
 let index2 = 1;
 let present2 = 0;
 let iarr2 = [];
 let left = false;
 let wwmb;
 if (view === "3" && i1 !== undefined && !hindit) wwmb = true;
 else wwmb = false;
 const [wwm, setWwm] = useState(wwmb);
 const [anchorEl, setAnchorEl] = useState(null);


 function goback() {
  setBplay({ fold: 0, song: 0 });

  if(history.length > 1){
    history.goBack()
  }else{
    history.push("/home")
  }
 }

 let fun =
  hindit && iskcon.songs[nind].hindi
   ? iskcon.songs[nind].hbody
   : iskcon.songs[nind].body;

 while (true) {
  if (fun.indexOf("(" + index.toString() + ")", present) !== -1) {
   present = fun.indexOf("(" + index.toString() + ")", present);
   iarr.push(index.toString());
   index++;
  } else {
   break;
  }
 }
 let fun2;
 let ztextr;
 if (i1 !== undefined) {
  fun2 =
  content[i1].chap.length > 0
   ? content[i1].chap[i2].song[id].body
   : content[i1].song[id].body;

  while (true) {
   if (fun2.indexOf("Text " + index2.toString(), present2) !== -1) {
    present2 = fun2.indexOf("Text " + index2.toString(), present2);
    iarr2.push(index2.toString());
    index2++;
   } else {
    break;
   }
  }

  if (fun2.indexOf("(refrain)") !== -1) {
   ztextr = fun2.slice(fun2.indexOf("(refrain)"), fun2.indexOf("Text 1")).split(/\r\n|\n/);
  }
 }

const toolbar = <IonToolbar color={colorh}>
  <IonButtons slot="start">
   <IonButton onClick={goback}>
   <ArrowBackSharp style={{ fontSize: 30 }} />
   </IonButton>
  </IonButtons>
  <IonButtons slot="start">
   <IonLabel style={{ fontFamily: `${fon}` }}>{hindit && iskcon.songs[nind].hindi ? iskcon.songs[nind].hindi : songName}</IonLabel>
  </IonButtons>
  <></>
  {!wwm ? (
   <>
    {vtb ? (
     <IonButtons slot="end">
      <IonButton
       onClick={() => {
        setVtb(!vtb);
       }}
      >
       <ViewHeadlineSharp />
      </IonButton>
     </IonButtons>
    ) : (
     <IonButtons slot="end">
      <IonButton
       onClick={() => {
        if (hindit) setVtb(!vtb);
        else setWwm(!wwm);
       }}
      >
       <ViewAgendaSharp />
      </IonButton>
     </IonButtons>
    )}
   </>
  ) : (
   <>
    {hindit ? null : (
     <IonButtons slot="end">
      <IonButton
       onClick={() => {
        setWwm(!wwm);
        setVtb(!vtb);
       }}
      >
       <MenuBookSharp />
      </IonButton>
     </IonButtons>
    )}
   </>
  )}
  <IonButtons slot="end">
   <IonButton
    onClick={(e) => {
      setAnchorEl(e.currentTarget);
    }}
    style={{marginRight:"7px"}}
   >
    <MoreVertSharp />
   </IonButton>
  </IonButtons>
 </IonToolbar>;

 return (
  <IonPage>
    <Helmet>
      <title>{songName}</title>
      <meta name="description" content={songName} />
  </Helmet>

   
   {!(userAudios[songName] && userAudios[songName].type === "youtube") && header==="true" ? <IonHeader className="lhide print-hide">
      {toolbar}
    </IonHeader> : null}

    {(userAudios[songName] && userAudios[songName].type === "youtube") ? <YouTubePlayer
    colorh={colorh}
    userAudios={userAudios}
    name={songName}
     /> : null}
  
  
   <IonContent color={colori} >

   {((userAudios[songName] && userAudios[songName].type === "youtube") || header !=="true") ? <div className="lhide print-hide">{toolbar}</div> : null} 
   <div className="phide print-hide">{toolbar}</div>
   <motion.div
    exit={{
     opacity: 0,
    }}
    animate={{ opacity: 1 }}
    initial={{ opacity: 0 }}
    transition={{ type: "linear", duration: 1 }}
   >
    <ScrollToTop />


     <div className="print-visible" style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 0 0", fontFamily: `${fon}` }}>
    <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}`, padding:0, marginBottom:0 }}>
    <IonCardContent style={{padding:0}}>
    <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${(Number(tsize)+8)}px` }}>
    {songName}
    </div>
    </IonCardContent>
   </IonCard>
   </div>
  
    
    {!wwm ? (
     <div style={{ margin: "0" }}>
      {" "}
      {vtb ? (
       <div style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 2px 0", fontFamily: `${fon}` }}>
        {iarr.map((sent, i) => {
         let ind1 = fun.indexOf("(" + sent + ")");
         let ind2 = fun.indexOf(i < iarr.length - 1 ? "(" + iarr[i + 1] + ")" : "TRANSLATION");

         let zen = fun.slice(ind1, ind2);
         let ztext = zen.split(/\r\n|\n/);

         let ind3 = fun.indexOf(sent + ")", fun.indexOf("TRANSLATION"));
         let ind4 = fun.indexOf(i < iarr.length - 1 ? iarr[i + 1] + ")" : "Song Name", fun.indexOf("TRANSLATION"));
         let zen1;
         if (sent <= 9) {
          zen1 = hindit && iskcon.songs[nind].hindi ? fun.slice(ind3 + 3, ind4 - 1) : fun.slice(ind3 + 2, ind4);
         } else {
          zen1 = hindit && iskcon.songs[nind].hindi ? fun.slice(ind3 + 4, ind4 - 1) : fun.slice(ind3 + 3, ind4);
         }
         let ztext1 = zen1.split(/\r\n|\n/);

         if (i === 0 && fun.indexOf("(refrain)") !== -1) {
          let indr = fun.indexOf("(refrain)");

          let indR = fun.indexOf("Refrain:");

          let zenr = hindit && iskcon.songs[nind].hindi ? fun.slice(indr, ind1).replace("(refrain)", "(टेक)") : fun.slice(indr, ind1);
          let ztextr = zenr.split(/\r\n|\n/);

          let zenR = hindit && iskcon.songs[nind].hindi ? fun.slice(indR, ind3 - 1).replace("Refrain", "टेक") : fun.slice(indR, ind3);
          let ztextR = zenR.split(/\r\n|\n/);

          return (
           <div key={i}>
            <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
             <IonCardContent>
              {ztextr.map((vad, j) => {
               return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
              })}
              {indR !== -1 ? <br /> : ""}
              {ztextR.map((vad1, j) => {
               return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
              })}
             </IonCardContent>
            </IonCard>

            <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
             <IonCardContent>
              {ztext.map((vad, j) => {
               return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
              })}
              <br />
              {ztext1.map((vad1, j) => {
               return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
              })}
             </IonCardContent>
            </IonCard>
           </div>
          );
         }

         return (
          <IonCard key={i} color={colori} style={{ fontFamily: `${fon}`, color: `${color2}` }}>
           <IonCardContent>
            {ztext.map((vad,j) => {
             return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
            })}
            <br />
            {ztext1.map((vad1,j) => {
             return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
            })}
           </IonCardContent>
          </IonCard>
         );
        })}
       </div>
      ) : (
       <div style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 2px 0" }}>
        <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
         <IonCardContent>
          {iarr.map((sent, i) => {
           let ind1 = fun.indexOf("(" + sent + ")");
           let ind2 = fun.indexOf(i < iarr.length - 1 ? "(" + iarr[i + 1] + ")" : "TRANSLATION");

           let zen = fun.slice(ind1, ind2);
           let ztext = zen.split(/\r\n|\n/);

           if (i === 0 && fun.indexOf("(refrain)") !== -1) {
            let indr = fun.indexOf("(refrain)");

            let zenr = hindit && iskcon.songs[nind].hindi ? fun.slice(indr, ind1).replace("(refrain)", "(टेक)") : fun.slice(indr, ind1);
            let ztextr = zenr.split(/\r\n|\n/);

            return (
             <div key={i}>
              <div>
               {ztextr.map((vad, j) => {
                return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
               })}
              </div>

              <div>
               {ztext.map((vad, j) => {
                return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
               })}
              </div>
             </div>
            );
           }

           return (
            <div key={i}>
             {ztext.map((vad, j) => {
              return <div key={i+""+j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
             })}
            </div>
           );
          })}{" "}
         </IonCardContent>
        </IonCard>

        <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
         <IonCardContent>
          <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>{hindit && iskcon.songs[nind].hindi ? "अर्थ" : "Translation"}</div>
          {iarr.map((sent, i) => {
           let ind3 = fun.indexOf(sent + ")", fun.indexOf("TRANSLATION"));
           let ind4 = fun.indexOf(i < iarr.length - 1 ? iarr[i + 1] + ")" : "Song Name", fun.indexOf("TRANSLATION"));

           let zen1 = hindit && iskcon.songs[nind].hindi ? fun.slice(ind3, ind4 - 1) : fun.slice(ind3, ind4);
           let ztext1 = zen1.split(/\r\n|\n/);

           if (ztext1[0].length < 5) return null;
           else {
            if (i === 0 && fun.indexOf("(refrain)") !== -1) {
             let indR = fun.indexOf("Refrain:");

             let zenR = hindit && iskcon.songs[nind].hindi ? fun.slice(indR, ind3 - 1).replace("Refrain", "टेक") : fun.slice(indR, ind3);
             let ztextR = zenR.split(/\r\n|\n/);

             return (
              <div key={i}>
               <div>
                <br />
                {ztextR.map((vad1,j) => {
                 return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
                })}
               </div>

               <div>
                <br />
                {ztext1.map((vad1, j) => {
                 return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
                })}
               </div>
              </div>
             );
            }

            return (
             <div key={i}>
              <br />
              {ztext1.map((vad1, j) => {
               return <div key={i+""+j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
              })}
             </div>
            );
           }
          })}
         </IonCardContent>
        </IonCard>
       </div>
      )}
     </div>
    ) : (
     <div style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 2px 0", fontFamily: `${fon}` }}>
      {i1 !== undefined ? (
       <div>
        {" "}
        {fun2.indexOf("(refrain)") !== -1 ? (
         <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
          <IonCardContent>
           {ztextr.map((vad, i) => {
            if (vad.indexOf(";") !== -1) {
             left = true;
            }

            if (vad.indexOf(";") !== -1) {
             let dk = vad.length - 1;

             while (vad[dk] === " ") {
              dk--;
             }

             if (vad.indexOf(".") === -1 && vad[dk] !== "!" && vad[dk] !== "?") {
              ztextr[i + 1] = ztextr[i].concat(ztextr[i + 1]);
             } else {
              vad = vad.replace(/—/g, "-");
              vad = vad.replace(/--/g, "-");
              vad = vad.replace(/–/g, "-");
              let oword = vad.split(";");

              return (
               <div key={i}>
                <br />
                <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>
                 {oword.map((word, iword) => {
                  let english = word.slice(word.lastIndexOf("-") + 1);
                  let sanskrit = word.slice(0, word.lastIndexOf("-"));

                  return (
                   <>
                    <span style={{ fontWeight: 600, color: `${color3}` }}>{sanskrit}</span> — <span>{english}</span>
                    {iword !== oword.length - 1 ? "; " : null}
                   </>
                  );
                 })}
                </div>
               </div>
              );
             }
            } else if (left && vad.indexOf(";") === -1) {
             if (i !== ztextr.length - 1) {
              ztextr[i + 1] = ztextr[i].concat(ztextr[i + 1]);
             } else {
              return (
               <div key={i}>
                <br />
                <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad}</div>
               </div>
              );
             }
            } else {
             let start = 0;
             while (true) {
              if (vad[start] === " ") {
               start++;
              } else {
               break;
              }
             }

             if (fun2.indexOf(";") === -1 && (vad[start] === "“" || vad[start] === "." || (vad[start] >= "A" && vad[start] <= "Z"))) {
              if (i !== ztextr.length - 1) {
               ztextr[i + 1] = ztextr[i].concat(ztextr[i + 1]);
              } else {
               return (
                <div key={i}>
                 <br />
                 <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad}</div>
                </div>
               );
              }
             } else {
              return <div key={i} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
             }
            }
            return null
           })}
          </IonCardContent>
         </IonCard>
        ) : null}
       </div>
      ) : null}
      {i1 !== undefined ? (
       iarr2.map((sent, i) => {
        let test = fun2.indexOf("Text " + iarr2[iarr2.length - 1]);

        if (fun2.indexOf("Text 1", test + 15) === -1) {
         let ind1 = fun2.indexOf("Text " + sent);
         let ind2 = i < iarr2.length - 1 ? fun2.indexOf("Text " + iarr2[i + 1]) : fun2.length;

         let zen = "";
         if (i < 9) {
          zen = fun2.slice(ind1 + 6, ind2);
         } else if (i < 100) {
          zen = fun2.slice(ind1 + 7, ind2);
         } else {
          zen = fun2.slice(ind1 + 8, ind2);
         }

         let ztext = zen.split(/\r\n|\n/);

         left = false;

         return (
          <IonCard key={i} color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
           <IonCardContent>
            <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>Text {sent} </div>
            {ztext.map((vad, i) => {
             if (vad.indexOf(";") !== -1) {
              left = true;
             }

             if (vad.indexOf(";") !== -1) {
              let dk = vad.length - 1;

              while (vad[dk] === " ") {
               dk--;
              }

              if (vad.indexOf(".") === -1 && vad[dk] !== "!" && vad[dk] !== "?") {
               ztext[i + 1] = ztext[i].concat(ztext[i + 1]);
              } else {
               vad = vad.replace(/—/g, "-");
               vad = vad.replace(/--/g, "-");
               vad = vad.replace(/–/g, "-");
               let oword = vad.split(";");

               return (
                <div key={i}>
                 <br />
                 <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>
                  {oword.map((word, iword) => {
                   let english = word.slice(word.lastIndexOf("-") + 1);
                   let sanskrit = word.slice(0, word.lastIndexOf("-"));
                   return (
                    <span key={i+""+iword}>
                     <span  style={{ fontWeight: 600, color: `${color3}` }}>{sanskrit}</span> — <span>{english}</span>
                     {iword !== oword.length - 1 ? "; " : null}
                    </span>
                   );
                  })}
                 </div>
                </div>
               );
              }
             } else if (left && vad.indexOf(";") === -1) {
              if (vad.indexOf("Text " + sent) !== -1) {
               vad = vad.replace("Text " + sent, "");
              }
              if (i !== ztext.length - 1) {
               ztext[i + 1] = ztext[i].concat(ztext[i + 1]);
              } else {
               return (
                <div key={i}>
                 <br />
                 <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad}</div>
                </div>
               );
              }
             } else {
              let start = 0;
              while (true) {
               if (vad[start] === " ") {
                start++;
               } else {
                break;
               }
              }

              if (fun2.indexOf(";") === -1 && (vad[start] === "“" || vad[start] === "." || (vad[start] >= "A" && vad[start] <= "Z"))) {
               if (i !== ztext.length - 1) {
                ztext[i + 1] = ztext[i].concat(ztext[i + 1]);
               } else {
                return (
                 <div key={i}>
                  <br />
                  <div style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad}</div>
                 </div>
                );
               }
              } else {
               return <div key={i} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
              }
             }
             return null
            })}
           </IonCardContent>
          </IonCard>
         );
        } else {
         let ind1 = fun2.indexOf("Text " + sent);
         let ind2 = i < iarr2.length - 1 ? fun2.indexOf("Text " + iarr2[i + 1]) : fun2.indexOf("Text 1 ", ind1);

         let zen = "";
         if (i < 9) {
          zen = fun2.slice(ind1 + 6, ind2);
         } else {
          zen = fun2.slice(ind1 + 7, ind2);
         }
         let ztext = zen.split(/\r\n|\n/);

         let ind3 = fun2.indexOf("Text " + sent, ind1 + 8);
         let ind4 = i < iarr2.length - 1 ? fun2.indexOf("Text " + iarr2[i + 1], ind2 + 8) : fun2.length;

         let zen1 = fun2.slice(ind3, ind4);
         let ztext1 = zen1.split(/\r\n|\n/);
         return (
          <IonCard key={i} color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
           <IonCardContent>
            <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>Text {sent}</div>
            {ztext.map((vad, i) => {
             return <div key={i} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
            })}
            {ind3 !== -1 ? <br /> : <div></div>}
            {ztext1.map((vad1,j) => {
             if (vad1.indexOf("Text " + sent) !== -1) {
              vad1 = vad1.replace("Text " + sent, "");
             }
             return <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
            })}
           </IonCardContent>
          </IonCard>
         );
        }
       })
      ) : (
       <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
        <IonCardContent>
         <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>
          Sorry Prabhuji/Mataji, we are currently not having the word to word meanings for this Song
         </div>
        </IonCardContent>
       </IonCard>
      )}
     </div>
    )}

    

   
   </motion.div>


   </IonContent>

  <Music
   songName = {songName}
   hsongName = {iskcon.songs[nind].hindi}
   songList = {iskcon.songs[nind].link}
   songPath = {`/home/songs/${songName}_${iskcon.songs[nind].book ?? ""}`}
   colorh={colorh}
   fon={fon}
   colori={colori}
   anchorEl={anchorEl}
   setAnchorEl={setAnchorEl}
   share_url={share_url}
    />
  </IonPage>
 );
}

export default Csong;
